import React, { useContext } from "react";
import { Button} from '@mui/material';
import {  useLocation, useNavigate } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import { ContextData } from "../../context/Context";
import { toast } from "react-toastify";


function Header() {


  var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const {Person,logout,loggingOut,Refresh,setRefresh} = useContext(ContextData)

  var day = new Date().getDate();
  var month = new Date().getMonth();
  var year = new Date().getFullYear();

  var hour = new Date().getHours();
  var minutes = new Date().getMinutes();

  const Navigate = useNavigate();
  const UseLocation = useLocation()

    // Navigate to Next route

    const handleNextPage = () =>{

      if( UseLocation.pathname === "/dashboard/report_statistics" ){
        Navigate("/dashboard/statistics")
      }else{
        Navigate("/dashboard/report_statistics")
      }
  }

// Next Page to logs route
const handleNextPageToLogs = ()=>{
  Navigate("/dashboard/logs")
}



// Next Page to settings route
const handleNextPageToSettings = ()=>{
  Navigate("/dashboard/settings")
}

const RefreshPage = () =>{
  setRefresh(!Refresh)
}

  const isActive = (pathName) =>{

    return UseLocation.pathname === pathName

  }


    const Logout = async () => {
      try { await logout(); } catch (error) { toast.error(error.message); }
    };

  const pageTitles = {
    profile: 'My profile', members: 'Members', statistics: 'Statistics', report_statistics: 'Reports',
    payment: 'Registration fees', adminusers: 'Admin users', user: 'Registration users',
    verification: 'Verification', approve: 'Approval', pending: 'Pending registrations',
    id_card: 'ID cards', prentable_disc: 'Printable cards', commission: 'Commissions',
    pay: 'Payments', logs: 'Activity logs', settings: 'Account settings'
  };
  const pageTitle = pageTitles[UseLocation.pathname.split('/').pop()] || 'Dashboard';

  return (
    <header className="header dashboard-header hide-at-prnt">
      <div className="dashboard-heading">
        <p>FITYANUL ISLAM / WORKSPACE</p>
        <h1>{pageTitle}</h1>
        <span>Welcome back{Person?.fname ? `, ${Person.fname}` : ''}.</span>
      </div>
      <div className="dashboard-header-actions">
        {Person !== null && Person.acc_level === "100" && <>
          <Button onClick={handleNextPage} variant="outlined">Reload Point</Button>
          <Button onClick={handleNextPage} variant="outlined">{UseLocation.pathname === "/dashboard/statistics" ? "Local Report" : "Finance Report"}</Button>
          <Button onClick={handleNextPageToLogs} variant="outlined">Logs</Button>
          <Button onClick={handleNextPageToSettings} variant="outlined" aria-label="Account settings" title="Account settings"><SettingsIcon fontSize="small" /></Button>

        </>}
        {Person !== null && Person.acc_level === "0" && <>
          <Button onClick={RefreshPage} variant="outlined">Refresh page</Button>
          <Button onClick={handleNextPageToSettings} variant="outlined" aria-label="Account settings" title="Account settings"><SettingsIcon fontSize="small" /></Button>

        </>}
        <Button onClick={Logout} disabled={loggingOut} variant="contained">{loggingOut ? 'Signing out…' : 'Logout'}</Button>
      </div>
    </header>
  );
}

export default Header;
